<template>
  <div>
    <div class="order-list">
      <!--<el-tabs  class="tt-custom-tab" v-model="type" @tab-click="tabChange()">
        <el-tab-pane v-for="(tab,index) in tabs" :key="index" :label="tab.label" :name="tab.name">
          <Orders ref="orders" v-on:totalCount="getTotalCount" v-if="type === tab.name" :type="type" :isSingle="isSingle"></Orders>
        </el-tab-pane>
      </el-tabs>-->
      <!--<div style="margin-bottom:30px;float: right;">
        <el-button type="info" @click="openNewOrder" native-type="button">
          新增订单
        </el-button>
      </div>-->
      <Orders ref="orders" v-on:totalCount="getTotalCount" :type="type" :isSingle="isSingle"></Orders>
      <Empty v-if="totalCount == 0 && !havKeyword" class="empty-content" :isSingle="isSingle"></Empty>
      <!-- <FloatingChat></FloatingChat> -->
    </div>
  </div>
</template>

<script>
import FloatingChat from '../../../components/FloatingChat'
import Empty from './Empty'
import Orders from './Orders'
import { API_HOST, FILE_HOST } from '../../../services/constant.js'
import api from '../../../services/api.js'

export default {
  name: 'MerchantOrderList',
  created () {
    this.loginByWx()
    this.init()
  },
  components: {
    FloatingChat,
    Empty: Empty,
    Orders: Orders,
  },
  data () {
    return {
      type: 'all',
      tabs: [],
      isSingle: false,
      totalCount: null,
      havKeyword: false,
      buyerTabs: [
        {label: '全部', name: 'all'},
        {label: '未完成', name: '11,12,13,14,15,16'},
        {label: '已完成', name: '20'},
        {label: '已取消', name: '30'}
      ],
      singleTabs: [
        {label: '全部', name: 'all'},
        {label: '待发货', name: '15'},
        {label: '已发货', name: '16'},
        {label: '已取消', name: '30'}
      ]
    }
  },
  methods: {
    init () {
      this.type = null
      if (this.$route.fullPath.indexOf('buyer') > -1) {
        this.isSingle = true
        this.tabs = this.singleTabs
      } else {
        this.isSingle = false
        this.tabs = this.buyerTabs
      }
      setTimeout(() => {
        this.type = this.$route.query.type || 'all'
      })
    },
    tabChange() {
      this.totalCount = null
      this.$router.push(
        {
          path: this.$route.path,
          query: {
            type: this.type
          }
        }
      )
    },
    getTotalCount(data) {
      this.totalCount = data.totalCount
      this.havKeyword = data.havKeyword
    },
    async loginByWx () {
      let token =  this.$localStorage.get('token')
      if(!token){
        if(this.$route.query.random_string){
                let random_string = this.$route.query.random_string
                let res = await api.post(this, {
                  path: 'passport.php',
                  api: 'login_by_random',
                  data: {
                    random_string:random_string
                  },
                  loading: 'loading'
                })
                if(res.body.status == 'ok'){
                  this.$localStorage.set('token', res.body.result)
                   window.location.reload()
                }
              }
            }

      }
      
  },
  watch:{
    $route(val, oldVal){
      if (val.path !== oldVal.path) {
        this.init()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.empty-content {
  padding: 50px 0 50px;
}
</style>

<style scoped lang="scss">
.order-list {
  margin-bottom: 80px;
  position: relative;
  .el-tabs__content {
    overflow: visible;
  }
}
.block.new{
  position: absolute;
  right: 0;
  top:0;
  width:100px !important;
  height: 40px !important;
}
.form-row{
  height: 50px;
  width:100%;
  margin-bottom:10px;
}
.el-input__inner{
  height:50px;
}
</style>



// WEBPACK FOOTER //
// src/pages/merchantOrders/list/List.vue